import { GlobalConfigType } from 'actions'
import { type InputType, type LoanFieldProps, FieldOrigin } from 'config'
import { store } from 'reducers'
import type { FormTableHeader } from 'stories/components'

export const header = (): FormTableHeader[] => {
  const inputs = defaultInputs()

  const keys = ['firstName', 'lastName', 'email', 'phone', 'dob', 'ssn', 'presentAddress']

  return keys
    .filter((key) => !!inputs[key] && inputs[key].visible !== false)
    .map((key) => ({ key, title: inputs[key].title }))
}

export const hasRecordInputs = (): Record<string, InputType> => {
  return {
    hasAdditionalMember: {
      inputType: 'check',
      title: 'Has Additional Entity Members?',
      required: true,
      history: true,
    },
  }
}

export const defaultInputs = (original = false): Record<string, InputType> => {
  const inputs: Record<string, InputType> = {
    firstName: {
      inputType: 'text',
      title: 'First Name',
      required: true,
    },
    lastName: {
      inputType: 'text',
      title: 'Last Name',
      required: true,
    },
    email: {
      inputType: 'text',
      type: 'email',
      title: 'Email',
      required: true,
    },
    phone: {
      inputType: 'text',
      type: 'phone',
      title: 'Phone',
      required: true,
    },
    dob: {
      inputType: 'text',
      type: 'date',
      title: 'DOB(MM/DD/YYYY)	',
      required: true,
    },
    ssn: {
      inputType: 'text',
      type: 'ssn',
      title: 'Social Security Number',
      required: true,
    },
    presentAddress: {
      inputType: 'map',
      title: 'Present Address',
      required: true,
    },
    membershipPercentage: {
      inputType: 'text',
      prefix: '%',
      value: 0,
      title: 'Membership Percentage',
      required: true,
    },
  }
  if (original) return inputs

  const { globalConfigReducer } = store.getState()
  const loanFieldProperties = globalConfigReducer[GlobalConfigType.LoanFields] as LoanFieldProps
  const { [FieldOrigin.AdditionalMember]: inputProps = {} } = loanFieldProperties

  Object.keys(inputProps).forEach((key) => {
    ;['required', 'title', 'tooltip', 'visible'].forEach((subKey) => {
      if (inputProps[key] && (inputProps[key] as any)[subKey] !== undefined)
        (inputs[key] as any)[subKey] = (inputProps[key] as any)[subKey]
    })

    if (inputProps[key] && inputProps[key].defaultValue !== undefined) inputs[key].value = inputProps[key].defaultValue
  })

  return inputs
}
